import streamMap from '../../config/stream';

export default {
  getStreamUuid: (env, company) => (streamMap[env][company] ? streamMap[env][company] : company),
};
